import styled from "styled-components";

export const PropertyLabel = styled.td`
  width: 1%;
  white-space: nowrap;
  color: #6c798f;
  font-size: 0.9em;
  vertical-align: top;
  padding-top: 5px;
  && {
    vertical-align: middle;
  }
`;
